module.exports = __webpack_public_path__ + "static/img/preview-01.5a4cf7a5.webp";